// PR-J — TPS Oversight query-key factory. Lives in its own *Keys file so the
// stale-after-save gate recognises it (the gate skips files matching
// /[Kk]eys\.tsx?$/) and mutations can invalidate by prefix. The console reads
// share the ["portfolio-admin","tps-oversight"] root; the per-TPS fee schedule
// keys under the existing TPS surface root so it stays adjacent to tpsKeys.

export const tpsOversightKeys = {
  root: ["portfolio-admin", "tps-oversight"] as const,
  dashboard: () => ["portfolio-admin", "tps-oversight", "dashboard"] as const,
  approvalQueue: () =>
    ["portfolio-admin", "tps-oversight", "approval-queue"] as const,
  correctionQueue: () =>
    ["portfolio-admin", "tps-oversight", "correction-queue"] as const,
  money: () => ["portfolio-admin", "tps-oversight", "money"] as const,
  // Section 3 — the clearing-account fund-safety anomalies (Guardrails section).
  anomaliesRoot: () =>
    ["portfolio-admin", "tps-oversight", "anomalies"] as const,
  anomalies: (acknowledged?: boolean) =>
    ["portfolio-admin", "tps-oversight", "anomalies", acknowledged ?? "all"] as const,
  loansForTps: (tpsId: string) =>
    ["portfolio-admin", "tps-oversight", "loans", tpsId] as const,
  feeSchedule: (tpsId: string) =>
    ["portfolio-admin", "tps", tpsId, "fee-schedule"] as const,
};
